import React, { useState, useRef, useEffect } from 'react'
import moment from 'moment'
import axios from 'axios';
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Label,
} from 'reactstrap';
import { useSelector } from 'react-redux';
import { jsPDF } from "jspdf";
import { useParams, Link, useNavigate } from 'react-router-dom';
import SelectedImg from '../../../src/images/check.png'
import errorImg from '../../images/cross.png'
import "./BuildingDropDown.css"
import { environment } from '../../env';
import EmptyDoc from './../errorComponents/EmptyDoc';
import DocumentsCard from './../DocumentsCard/DocumentsCard';
import BuildingExcelTable from '../Tables/BuildingExcelTable';
import { Users, User } from '@phosphor-icons/react';
import PathName from '../PathName/PathName';
import PriceFormater from '../../Helper/PriceFormater';

function BuildingViewCard() {
    const [builddocs, setBuilddocs] = useState([])
    const [buildingdata, setBuildingData] = useState()
    const [soldgalaData, setsoldGalaData] = useState([])
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const [enableImg, setEnableImg] = useState(true)
    const buildingDetails = useRef(null)
    const navigate = useNavigate();
    const { id } = useParams()
    var galas = []

    const soldGalas = useSelector((state) => state?.ModalReducer?.soldGalaList);

    const viewBuildingData = () => {
        axios.get(`${environment.baseUrl}editbuilding/${id}`).then(res => {
            const currentDate = moment(new Date()).format('YYYY-MM-DD');
            const CompleteDate = moment(res?.data?.date_of_completion).format('YYYY-MM-DD')
            var date1 = moment(currentDate);
            var date2 = moment(CompleteDate);
            var days = date1.diff(date2, 'days')
            let years = date1.diff(date2, 'year');
            date2.add(years, 'years');
            let months = date1.diff(date2, 'months');
            date2.add(months, 'months');
            days = date1.diff(date2, 'days');
            date2.add(days, 'days');
            res.data.building_age = `${years} Years ${months} Months ${days} Days`
            let arr = []
            if (res.data?.fire_system_document != 'No Document Uploaded') {
                arr.push({ documentname: "fire_system_document", documenturl: JSON.parse(res.data.fire_system_document) })
            }
            if (res.data?.mazanine_facility_document != 'No Document Uploaded') {
                arr.push({ documentname: "mazanine_facility_document", documenturl: JSON.parse(res.data.mazanine_facility_document) })
            }
            if (res.data?.noc_document != 'No Document Uploaded') {
                arr.push({ documentname: "noc_document", documenturl: JSON.parse(res.data.noc_document) })
            }
            if (res.data?.solar_power_document != 'No Document Uploaded') {
                arr.push({ documentname: "solar_power_document", documenturl: JSON.parse(res.data.solar_power_document) })
            }
            if (res.data?.stability_certificate_document != 'No Document Uploaded') {
                arr.push({ documentname: "stability_certificate_document", documenturl: JSON.parse(res.data.stability_certificate_document) })
            }
            if (res.data?.electricity_document != 'No Document Uploaded') {
                arr.push({ documentname: "electricity_document", documenturl: JSON.parse(res.data.electricity_document) })
            }
            setBuilddocs(arr)
            setBuildingData(res.data);
        })
            .catch(res => {
                console.log("errorss");
            })
    }

    const pdfDownload = () => {
        setEnableImg(false)
        const content = buildingDetails.current;
        var doc = new jsPDF('l',)
        doc.html(content, {
            callback: (doc) => {
                window.open(doc.output('bloburl'));
                setEnableImg(true)
            },
            html2canvas: { scale: 0.204 },
            margin: [11, 2, 2, 2],
        })
    }


    const getGalaData = () => {
        let arr = [];
        const galalistt = soldGalas?.filter((gala) => gala?.building?.id == id)
        const tableArr = []
        galalistt?.map((curElem, i) => {
            tableArr.push({
                id: curElem.id,
                investor_name: curElem.Investors.name,
                project_name: curElem.project.name,
                building_name: curElem.building.building_no,
                gala_no: curElem.gala.gala_no,
                sub_gala_name: curElem.sub_gala_name,
                area: curElem.sold_gala_area - curElem.resell_area,
                ownership: curElem.ownership,
                ownertype: curElem.ownertype,
                created_at: curElem.created_at
            })
        })
        setsoldGalaData(tableArr)
    }


    const ordinal = (i) => {
        var j = i % 10,
            k = i % 100;
        if (j == 1 && k != 11) {
            return i + "st";
        }
        if (j == 2 && k != 12) {
            return i + "nd";
        }
        if (j == 3 && k != 13) {
            return i + "rd";
        }
        return i + "th";
    }

    const columns = [
        {
            name: 'Party Name',
            selector: row => row.investor_name,
            wrap:true,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Status',
            selector: (row) => <div className="d-flex justify-content-between align-items-center gap-2 ">
                <label className={`${row.ownership === 1 && 'icon-bg-green icon-color-green '} ${row.ownership === 2 && 'icon-bg-yellow icon-color-yellow'} ${row.ownership == 3 && 'status-bg-blue status-color-blue'} ${row.ownership >= 4 && 'bg-info text-white'}   rounded-pill status-box rounded fs-4`}>{`${ordinal(row.ownership)} Owner`}</label>
            </div>,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Owner Type',
            selector: row => <div className="d-flex justify-content-between align-items-center gap-3 " >
                <span>{row?.ownertype == "Self" ? <User size="26" className='text-base-red' /> : row?.ownertype == "Joined" && <Users size="26" className='status-color-blue' />}</span>
                <label className='fs-3'>{row?.ownertype}</label>
            </div >,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Created On',
            selector: row => moment(row.created_at).format('DD/MM/YYYY'),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Building No',
            selector: row => row.building_name,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },

        {
            name: 'Gala No',
            selector: row => Number(row.gala_no),
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        }, {
            name: 'Sub Gala',
            selector: row => row.sub_gala_name,
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
        {
            name: 'Area',
            selector: row => (row.area) + " " + "Sq.ft",
            sortable: true,
            style: {
                fontSize: "2.3rem",
            }
        },
    ];

    useEffect(() => {
        viewBuildingData();
    }, [])

    useEffect(() => {
        setBuilddocs(builddocs)
        getGalaData()
    }, [builddocs])



    return (
        <>
            <PathName />
            <div className="d-flex justify-content-between align-items-center py-5 px-3 pt-2">
                <button className="d-flex align-items-center border-0 bg-transparent" onClick={() => navigate(-1)}>
                    <i className='bx bx-arrow-back fs-2 title-font-600 px-2 bx-fade-left'></i>
                    <span className='fs-3 base-font-600'>Back</span> </button>
                <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                    <DropdownToggle className="border-0 bg-transparent">
                        <div className="buttons px-3 py-3 rounded-3"  >
                            <i className='bx-tada bx bx-download fs-1 base-text-color ' ></i>
                        </div>
                    </DropdownToggle>
                    <DropdownMenu className='shadow-lg bg-body rounded-4 border-0 dropdown-menus p-3 '>
                        <DropdownItem onClick={pdfDownload} className='border-0 outline-none px-2 py-2 d-flex align-items-center'>
                            <i className="fa-regular fa-file-pdf fs-1 base-text-color px-2"></i>
                            <span className='text-dark text-decoration-none title-font-500 fs-3 dropdown-item px-4'>PDF</span>

                        </DropdownItem>
                    </DropdownMenu>
                </Dropdown>
            </div>
            <div ref={buildingDetails} className="bg-white d-flex mb-5  flex-column border-radius-32">
                <div className='d-flex flex-column justify-content-center align-items-center align-items-md-center  align-items-lg-center align-items-xl-center align-items-sm-center bg-base-color p-3 p-sm-4 p-md-5 p-lg-5 p-xl-5 border-radius-32-top'>
                    <h1 className='title-font-600 text-base-white fs-1 text-capitalize'>{buildingdata?.building_no}</h1>
                    <p className='base-font-600 fs-3 text-base-white w-75 text-center '>{buildingdata?.project?.address1}, Near by-{buildingdata?.project?.near_by}, {buildingdata?.project?.village_name?.name},
                        {buildingdata?.project?.city?.city_name}, {buildingdata?.project?.state},  {buildingdata?.project?.country}, Pin - {buildingdata?.project?.pincode}</p>
                </div>
                <div className="card w-100 border-0 rounded-5 px-5">
                    <div className="row  p-3 p-sm-3 p-md-5 p-lg-5 p-xl-5">
                        <div className=" col-md-4 col-sm-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Project Name: <span className='fs-3 base-font-400'>{buildingdata?.project?.name}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Galas Created: <span className='fs-3 base-font-400'>{buildingdata?.gala_created == 0 ? "No Galas Created" : buildingdata?.gala_created}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Builtup Area: <span className='fs-3 base-font-400'>{buildingdata?.area_builtup} sq.ft</span> </h5>

                            </div>
                        </div>
                        <div className=" col-sm-4  col-md-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Building No: <span className='fs-3 base-font-400'>{buildingdata?.building_no} </span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Center Height: <span className='fs-3 base-font-400'>{buildingdata?.center_height} Ft</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Carpet Area: <span className='fs-3 base-font-400'>{buildingdata?.area_carpet} sq.ft</span> </h5>

                            </div>
                        </div>
                        <div className=" col-md-4 col-sm-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Construct Type: <span className='fs-3 base-font-400'>{buildingdata?.building_type.name} </span> </h5>

                                <h5 className="fs-3 base-font-700 mb-4">Side Height: <span className='fs-3 base-font-400'>{buildingdata?.side_height} Ft</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Available Area: <span className='fs-3 base-font-400'>{buildingdata?.available_area} Sq.Ft</span> </h5>
                            </div>
                        </div>
                    </div>
                    <div className="row  p-3 p-sm-3 p-md-5 p-lg-5 p-xl-5">
                        <div className="col-md-4 col-sm-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Dock: <span className='fs-3 base-font-400'>{buildingdata?.dock}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Floor Capacity: <span className='fs-3 base-font-400'>{buildingdata?.floor_capacity} Tons</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Front Side Road: <span className='fs-3 base-font-400'>{buildingdata?.front_side_length} Ft</span> </h5>

                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Auto Dock: <span className='fs-3 base-font-400'>{buildingdata?.auto_dock}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Shutter: <span className='fs-3 base-font-400'>{buildingdata?.shutter} </span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">In-Side Length: <span className='fs-3 base-font-400'>{buildingdata?.in_side_length_l} Ft X {buildingdata?.in_side_length_r} Ft</span> </h5>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Floor Type: <span className='fs-3 base-font-400'>{buildingdata?.floor_type.name}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Sliding Ramp: <span className='fs-3 base-font-400'>{buildingdata?.sliding_ramp}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Out-Side Length: <span className='fs-3 base-font-400'>{buildingdata?.out_side_length_l} Ft X {buildingdata?.out_side_length_r} Ft</span> </h5>

                            </div>
                        </div>
                    </div>

                    <div className="row  p-3 p-sm-3 p-md-5 p-lg-5 p-xl-5">
                        <div className="col-md-4 col-sm-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Permission Type: <span className='fs-3 base-font-400'>{buildingdata?.permission_type}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Service No: <span className='fs-3 base-font-400'>{buildingdata?.service_no}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Toilet: <span className='fs-3 base-font-400'>{buildingdata?.toilet}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Completion Date :<span className='fs-3 base-font-400'> {moment(buildingdata?.date_of_completion).format('DD/MM/YYYY')}</span> </h5>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Water Supply: <span className='fs-3 base-font-400'>{buildingdata?.water_supply}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Electricity Deposit: <span className='fs-3 base-font-400'> <PriceFormater price={buildingdata?.electricity_deposit} /></span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">No. of Toilet: <span className='fs-3 base-font-400'>{buildingdata?.no_of_toilet}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Building Age: <span className='fs-3 base-font-400'>{buildingdata?.building_age}</span> </h5>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="card-body">
                                <h5 className="fs-3 base-font-700 mb-4">Electric Supply: <span className='fs-3 base-font-400'>{buildingdata?.electricity_connection}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Meter Owner: <span className='fs-3 base-font-400'>{buildingdata?.meter_owner}</span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">No Of Light: <span className='fs-3 base-font-400'>{buildingdata?.no_of_light} lights </span> </h5>
                                <h5 className="fs-3 base-font-700 mb-4">Survey No: <span className='fs-3 base-font-400'>{buildingdata?.survey_no}</span> </h5>
                            </div>
                        </div>
                    </div>

                    <div className="row g-0 p-2">
                        <div className='row  p-3 p-sm-3 p-md-5 p-lg-5 p-xl-5'>
                            <div className="col-md-4 col-sm-4">
                                <div className="card-body">
                                    <h5 className="fs-3 base-font-700 mb-4 d-flex align-items-center "><span className='me-4'><img src={buildingdata?.fire_system ? SelectedImg : errorImg} alt="" /></span> Fire System</h5>
                                    <h5 className="fs-3 base-font-700 mb-4 d-flex align-items-center"><span className='me-4'><img src={buildingdata?.stability_certificate ? SelectedImg : errorImg} alt="" /></span> Stability Certificate</h5>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-4">
                                <div className="card-body">
                                    <h5 className="fs-3 base-font-700 mb-4 d-flex align-items-center"><span className='me-4'><img src={buildingdata?.solar_power ? SelectedImg : errorImg} alt="" /></span>Solar Power</h5>
                                    <h5 className="fs-3 base-font-700 mb-4 d-flex align-items-center"><span className='me-4'><img src={buildingdata?.noc ? SelectedImg : errorImg} alt="" /></span> Noc</h5>
                                </div>
                            </div>
                            <div className="col-md-4 col-sm-4">
                                <div className="card-body">
                                    <h5 className="fs-3 base-font-700 mb-4 d-flex align-items-center"><span className='me-4'><img src={buildingdata?.mazanine_facility ? SelectedImg : errorImg} alt="" /></span>Mazanine Facility</h5>
                                    <h5 className="fs-3 base-font-700 mb-4 d-flex align-items-center"><span className='me-4'><img src={buildingdata?.electricity ? SelectedImg : errorImg} alt="" /></span>Eletricity Permission</h5>
                                </div>
                            </div>
                        </div>
                        {
                            builddocs.length != 0 && enableImg && <div className="bg-white p-5 d-flex gap-5 flex-column rounded-5 mb-5">
                                <div className="d-flex justify-content-between align-items-center mb-5">
                                    <h1 className="title-font-bold ">Documents</h1>
                                </div>
                                {builddocs.length != 0 ? <DocumentsCard documentDetails={builddocs ? builddocs : galas} /> : <EmptyDoc />}
                            </div>
                        }
                    </div>

                </div>
            </div>
            <div className="bg-white p-5 d-flex flex-column rounded-5 mb-5">
                {soldgalaData?.length > 0 ? <BuildingExcelTable columns={columns} data={soldgalaData} /> :
                    <p className='fs-2 title-font-700 mb-0 text-base-color'>
                        No Investors Yet !
                    </p>}
            </div>
        </>



    )
}

export default BuildingViewCard




